import { Section } from "@/components/ui/section";
import { ScrollContainer } from "@/components/ui/scroll-container";
import { Button } from "@/components/ui/button";


export default function Showroom() {
  const locations = [
    { shortName: "Auckland", name: "Auckland Showroom", email: "Raya.Roy@nz.harveynorman.com", videoUrl: "https://example.com/auckland-tour" },
    { shortName: "Hamilton", name: "Hamilton Showroom", email: "Waikato.Commercial@nz.harveynorman.com", videoUrl: "https://example.com/hamilton-tour" },
    { shortName: "Tauranga", name: "Tauranga Showroom", email: "Commercial.BOP@nz.harveynorman.com", videoUrl: "https://example.com/tauranga-tour" },
    { shortName: "Wellington", name: "Wellington Showroom", email: "Porirua.ElecComm@nz.harveynorman.com", videoUrl: "https://example.com/wellington-tour" },
    { shortName: "Christchurch", name: "Christchurch Showroom", email: "commchch.admin@nz.harveynorman.com", videoUrl: "https://example.com/christchurch-tour" },
    { shortName: "Queenstown", name: "Queenstown Showroom", email: "brendon.follows@nz.harveynorman.com", videoUrl: "https://example.com/queenstown-tour" },
  ];

  
  const handleLocationClick = (location: { name: string; email: string }) => {
    const subject = encodeURIComponent(`Showroom Consultation & Tour Booking Request`);
    const body = encodeURIComponent(
      `Hi ${location.name} Team,\n\n` +
      `I’d like to book a showroom consultation and tour at your showroom. Here are my details:\n` +
      `• Full Name:\n` +
      `• Business Name:\n` +
      `• Mobile Number:\n` +
      `• Account Manager Name (if known):\n` +
      `• Preferred Date and Time:\n` +
      `• Any Special Requests or Additional Information:\n\n` +
      `Please let me know if you need anything else to confirm the booking.\n\nThank you!`
    );
    const mailto = `mailto:${location.email}?subject=${subject}&body=${body}`;
    window.open(mailto, "_blank");
  };
  
  return (
    <div className="w-screen overflow-y-scroll overflow-x-hidden bg-black z-0 no-scrollbar">
      <ScrollContainer snapType="y" snapBehavior="mandatory">
        <Section
          fullHeight={true}
          scrollSnap={true}
          variant="dark"
          padding="none"
          contained={true}
        >
          <div className="pt-24 pb-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-center mb-6 text-white drop-shadow-lg tracking-tight px-4">
              Step Inside Our <span className="hero-text-gradient-red">Virtual Showroom</span>
            </h1>

            <p className="text-lg md:text-xl lg:text-xl max-w-3xl mx-auto text-center mb-10 text-white/90 whitespace-normal px-4 lg:px-6 leading-relaxed">
              Experience Harvey Norman Commercial NZ like never before with our interactive virtual tour. Take an insider’s look at our Auckland Showroom, where innovative products meet expert design solutions.<br className="hidden md:block" />              
            </p>

            {/* Virtual Showroom - Centered */}
            <div className="flex justify-center w-full mb-12">
              <div className="w-full max-w-5xl rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://my.matterport.com/show/?m=dfy315sFdS9&play=1&qs=1&ts=3&hl=0"
                  width="100%"
                  height="500px"
                  frameBorder="0"
                  allowFullScreen
                  allow="xr-spatial-tracking"
                  title="Embedded Virtual Tour"
                  className="block w-full h-[500px] bg-black"
                ></iframe>
              </div>
            </div>



            <div className="w-full mt-8">
              <h2 className="text-2xl md:text-xl font-bold text-center text-white mb-6 tracking-tight">
                Book an In-Person Tour
              </h2>
              <p className="text-lg md:text-xl max-w-3xl mx-auto text-center mb-8 text-white/80 whitespace-normal px-4 lg:px-6">
                For an in-depth, personalised experience, schedule a showroom tour at any of our New Zealand locations:
              </p>
              <div className="flex flex-row flex-wrap justify-center gap-4 md:gap-6 lg:gap-8 text-white text-center pb-8 font-medium px-4">
                {locations.map((location) => (
                  <Button
                    variant="white"
                    key={location.name}
                    onClick={() => handleLocationClick(location)}
                    className="min-w-[160px] py-2 px-5 btn"
                  >
                    <span className="px-5">{location.shortName}</span>
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </Section>
      </ScrollContainer>
    </div>
  );
}